import styled from 'styled-components';

import { TextButton } from '@xingternal/button';
import { IconArrowDown } from '@xingternal/icons';
import { spaceL } from '@xingternal/tokens';

export const Container = styled.div`
  margin-bottom: ${spaceL};
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const TextButtonLink = styled(TextButton)`
  min-width: unset;
`;

export const ArrowLeft = styled(IconArrowDown)`
  transform: rotate(-90deg);
`;
